import React, { useEffect, useState } from 'react';
import { Button, Col, FormGroup, Row } from 'reactstrap';
import '../styles/servicebox.css';
import { Link } from 'react-router-dom';
import useFetch from '../hooks/useFetch';
import { BASE_URL } from '../config/config';
import { getHostCars, getTrips } from '../util/api';
import CarCard from './CarCard';
import jwtDecode from 'jwt-decode';

const HostBookings = props => {
  const { data } = props;
  console.log(':::::::',data)
  // const {
  //   data: services,
  //   isPending,
  //   error,
  // } = useFetch(
  //   `${BASE_URL}api/Booking/get-trips-user-by-Status?userId=${userId}=Booked`
  // );

  useEffect(() => {
    window.scrollTo(0, 0);
    const token = localStorage.getItem('token')
    const decoded = jwtDecode(token)
    console.log('dec',decoded)
    getHostCars(decoded.OwnerId).then(res => {
      console.log('res',res)
      setMyCar(res)
    });
  }, []);

  const [myCars, setMyCar] = useState([]);

 
  return (
    <>
     <div>
      <Row>
        {data && data.map((item, index) => (
          <Col key={index} sm="4">
            <TripsCard item={item} />
          </Col>
        ))}
      </Row>
    </div>
    </>
  );
};

const TripsCard = ({ item }) => {
  return (
    // <Col lg="4" md="4" sm="4" className="mb-5">
      <div className="carItem" style={{marginTop:20}}>
        <div className="car__item-img ">
          <img src={item.carImageUrl} alt="" className="w-100" style={{ height: '200px' }}/>
        </div>
        <div className="car__item-content mt-4">
          <h4 className="section__title text-center">
            {item.brandName + ' ' + item.carName}
          </h4>
          <h6 className="rent__price text-center mt-4">
            ${item.rentPerDay}.00 <span>/ Day</span>
          </h6>
          {/* <div className="text-center">
            <Button className="w-50 carItem__btn carItem__btn-details">
              <Link to={`/car-details/${item.carListId}`}>Details</Link>
            </Button>
          </div> */}
        </div>
      </div>
    // </Col>
  );
};

export default HostBookings;
